import {
    Box,
    DialogTitle as MuiDialogTitle,
    IconButton,
    TextField as MuiTextField,
    Typography
} from '@mui/material';
import { styled } from '@mui/system';

import color from '../../../../theme/color';

export const dialogPaperProps = {
    style: {
        backgroundColor: color.darkBlue,
        color: color.white,
        padding: '20px',
        borderRadius: '8px',
        margin: '16px',
        maxWidth: '600px'
    }
};

export const DialogTitle = styled(MuiDialogTitle)({
    textAlign: 'center',
    fontWeight: 'bold',
    paddingBottom: '8px'
});

export const DialogDescription = styled(Typography)({
    textAlign: 'center',
    fontSize: '14px',
    color: color.lightGray,
    marginBottom: '20px',
    padding: '0 24px',
    whiteSpace: 'pre-line'
});

export const ModalTextField = styled(MuiTextField)({
    '& .MuiOutlinedInput-root': {
        backgroundColor: color.darkBlue,
        borderRadius: '8px',
        color: color.white,
        fontSize: '14px',
        '& fieldset': {
            borderColor: color.darkGray
        },
        '&:hover fieldset': {
            borderColor: color.hitGray
        },
        '&.Mui-focused fieldset': {
            borderColor: color.lightningYellow
        }
    },
    '& .MuiInputBase-input': {
        color: color.white,
        fontSize: '14px'
    },
    '& .MuiInputBase-input::placeholder': {
        color: color.lightGray,
        opacity: 0.8
    }
});

export const ModalContent = styled(Box)({
    paddingTop: '0',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px'
});

export const ButtonContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    marginTop: '20px',
    width: '100%',
    maxWidth: '500px',
    marginLeft: 'auto',
    marginRight: 'auto'
});

export const CloseButton = styled(IconButton)({
    position: 'absolute',
    right: '8px',
    top: '8px',
    color: color.white,
    '&:hover': {
        backgroundColor: color.darkGray
    }
});

export const AttachmentsContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
    maxHeight: '150px',
    overflowY: 'auto',
    width: '100%',
    padding: '8px 0'
});

export const AttachmentIconButton = styled(Box)({
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: '4px',
    marginRight: '4px'
});

export const ErrorMessage = styled(Box)({
    color: color.errorRed,
    fontSize: '12px',
    width: '100%'
});

export const HiddenFileInput = styled('input')({
    display: 'none'
});

export const FooterButton = styled('button')<{ disabled?: boolean }>(
    ({ disabled }) => ({
        padding: '10px 20px',
        borderRadius: '20px',
        border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontSize: '14px',
        fontWeight: 500,
        transition: 'all 0.2s ease',
        minWidth: '100px',
        backgroundColor: disabled ? color.darkGray : color.lightningYellow,
        color: color.white,
        opacity: disabled ? 0.5 : 1,
        '&:hover': {
            backgroundColor: disabled ? color.darkGray : color.yellow60
        }
    })
);

export const CancelButton = styled('button')({
    padding: '10px 20px',
    borderRadius: '20px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 500,
    transition: 'all 0.2s ease',
    minWidth: '100px',
    backgroundColor: color.blackRock,
    color: color.white,
    '&:hover': {
        backgroundColor: color.darkGray
    }
});

export const LoadingOverlay = styled(Box)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(30, 32, 42, 0.7)',
    zIndex: 10,
    borderRadius: '8px'
});
